import React, { Fragment, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import FormatDate from '../Utils/FormatDate';
import Amount from '../Utils/Amount';
import VTabBar from '../Utils/VTabBar';
import TabBarItem from '../Utils/VTabBar/TabBarItem';
import Icon from '../Utils/Icon';
import classes from './styles.module.css';

function TableRow({ data }) {
    const [isOpened, setIsOpened] = useState(false);

    const type = {
        styles: { color: '#ff9800', borderColor: '#ff9800' },
        locale: null,
    };

    if (data && data.type) {
        switch (data.type) {
            case 'payoutDecline':
            case 'mobilePayoutDecline':
                type.styles = { color: '#dc3912', borderColor: '#dc3912' };
                type.locale = <FormattedMessage id="PayoutsTable.status.payoutDecline" defaultMessage="Ошибка" />;
                break;
            case 'created':
            case 'payoutCreated':
            case 'mobilePayoutCreated':
            case 'payoutPending':
            case 'mobilePayoutPending':
                type.styles = { color: '#2196f3', borderColor: '#2196f3' };
                type.locale = <FormattedMessage id="PayoutsTable.status.created" defaultMessage="Отложен" />;
                break;
            case 'payout':
            case 'mobilePayout':
                type.styles = { color: '#109618', borderColor: '#109618' };
                type.locale = <FormattedMessage id="PayoutsTable.status.payout" defaultMessage="Оплачен" />;
                break;
            case 'filtered':
                type.styles = { color: '#eca87a', borderColor: '#eca87a' };
                type.locale = <FormattedMessage id="PayoutsTable.status.filtered" defaultMessage="Отфильтрован" />;
                break;
            default:
                break;
        }
    }

    function toggleOpened() {
        setIsOpened((prev) => !prev);
    }

    return (
        <Fragment>
            <tr onClick={toggleOpened} className={classes.Row}>
                <td>
                    <div style={type.styles} className={classes.Status}>
                        <span style={type.styles} />
                        {type.locale}
                    </div>
                </td>
                <td>{(data && data.recipient) || ''}</td>
                <td>{(data && data.phone) || ''}</td>
                <td>
                    <Amount amount={data && data.amount} currency={data && data.currencyCode} />
                </td>
                <td>
                    {(data && data.firstPart) || ''} ••• {(data && data.lastPart) || ''}
                </td>
                <td className={classes.ToggleCell}>
                    {isOpened ? (
                        <Icon className={classes.Icon} icon="cheveron-up" size="18px" />
                    ) : (
                        <Icon className={classes.Icon} icon="cheveron-down" size="18px" />
                    )}
                </td>
            </tr>

            {isOpened && (
                <tr className={classes.InnerRow}>
                    <td colSpan={6}>
                        <VTabBar>
                            <TabBarItem
                                label={<FormattedMessage id="PayoutsTable.tab.params" defaultMessage="Параметры выплаты" />}
                                isVisible={true}
                            >
                                <table className={classes.TabTable}>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.id"
                                                    defaultMessage="Идентификатор операции:"
                                                />
                                            </td>
                                            <td>{(data && data.id) || ''}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.fee"
                                                    defaultMessage="Комиссия:"
                                                />
                                            </td>
                                            <td>
                                                {data && data.fee ? (
                                                    <Amount amount={data.fee} currency={data.currencyCode} />
                                                ) : (
                                                    '—'
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.extStatus"
                                                    defaultMessage="Расширенный статус:"
                                                />
                                            </td>
                                            <td>{(data && data.status) || '—'}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.created"
                                                    defaultMessage="Создан:"
                                                />
                                            </td>
                                            <td>
                                                <FormatDate
                                                    setDate={data && data.date}
                                                    format={{
                                                        day: 'numeric',
                                                        month: 'numeric',
                                                        year: 'numeric',
                                                        hour: 'numeric',
                                                        minute: 'numeric',
                                                    }}
                                                />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.processed"
                                                    defaultMessage="Выполнен:"
                                                />
                                            </td>
                                            <td>
                                                {data && data.accountingDate ? (
                                                    <FormatDate
                                                        setDate={data.accountingDate}
                                                        format={{
                                                            day: 'numeric',
                                                            month: 'numeric',
                                                            year: 'numeric',
                                                            hour: 'numeric',
                                                            minute: 'numeric',
                                                        }}
                                                    />
                                                ) : (
                                                    '—'
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.bank"
                                                    defaultMessage="Банк карты:"
                                                />
                                            </td>
                                            <td>{(data && data.cardBankName) || '—'}</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.country"
                                                    defaultMessage="Страна карты:"
                                                />
                                            </td>
                                            <td>
                                                {data && data.cardBankCountryCode ? (
                                                    <FormattedMessage
                                                        id={`binBase.country.${data.cardBankCountryCode}`}
                                                        defaultMessage={data.cardBankCountryCode}
                                                    />
                                                ) : (
                                                    '—'
                                                )}
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <FormattedMessage
                                                    id="PayoutsTable.tab.system"
                                                    defaultMessage="Платежная система:"
                                                />
                                            </td>
                                            <td>{(data && data.cardBrand) || '—'}</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </TabBarItem>
                        </VTabBar>
                    </td>
                </tr>
            )}
        </Fragment>
    );
}

export default TableRow;



// WEBPACK FOOTER //
// ./src/Components/PayoutsTable/TableRow.js